export default __webpack_public_path__ + "static/media/icon-hourglass.759ddcc8.svg";